// …/Functions/GetContextMenuItems.tsx
import React from 'react';
import {
  EmailIcons,
  LinkIcons,
  NotebookIcons,
  UserPenIcons,
  VideoIcons,
} from '../../../../../../../icons/icons';
import { MenuItemType } from '../../../../../../../ui';
import { PencilIcon, TrashIcon } from '../../../../../../../ui/icons/icons';
import { Permission } from '../../../../../../../utils/helpers/permissions';
import { ICandidate } from '../../../../../../../utils/types/JobOpenings';

interface IMenuItemsColumns {
  onDelete: (row: ICandidate) => void;
  onUpdate: (row: ICandidate) => void;
  onConfirmInterview: (row: ICandidate) => void;
  onRecordInterview?: (row: ICandidate) => void;
  onJoinMeeting?: (row: ICandidate) => void;
  onPanelistNotes: (row: ICandidate) => void;
  recordingRowId?: string;
}

/**
 * Build the menu *for a specific row*.
 * Only if status === "Scheduled" will we include Update & Confirm.
 */
export const getMenuItemsForMenu =
  ({
    onDelete,
    onUpdate,
    recordingRowId,
    onConfirmInterview,
    onJoinMeeting,
    onPanelistNotes,
    onRecordInterview,
  }: IMenuItemsColumns) =>
    (row: ICandidate): MenuItemType<ICandidate>[] => {
      const items: MenuItemType<ICandidate>[] = [];

      // Only show Update & Confirm when they’re scheduled
      if (row.interviewApplicantStatus === 'Scheduled') {
        items.push({
          label: 'Update Details',
          icon: <PencilIcon />,
          permission: [],
          onClick: () => onUpdate(row),
        });
      }
      if (
        row.interviewApplicantStatus === 'Scheduled' &&
      (row.inPersonAddress || row.meetingLink)
      ) {
        items.push({
          label: 'Confirm Interview',
          icon: <EmailIcons />,
          permission: [],
          onClick: () => onConfirmInterview(row),
        });
      }
      if (
        row.interviewApplicantStatus === 'Confirmed' &&
      (row.inPersonAddress || row.meetingLink)
      ) {
        items.push({
          label: 'Panelist Notes',
          icon: <UserPenIcons />,
          permission: [],
          onClick: () => onPanelistNotes(row),
        });
      }
      if (row.interviewApplicantStatus === 'Confirmed' && row.inPersonAddress) {
        items.push({
          label: recordingRowId === row.id ? 'Stop Recording' : 'Record Meeting',
          icon: <VideoIcons />,
          permission: [],
          onClick: () => onRecordInterview && onRecordInterview(row),
        });
      }

      if (row.interviewApplicantStatus === 'Confirmed' && row.meetingLink) {
        items.push({
          label: 'Join Meeting',
          icon: <LinkIcons />,
          permission: [],
          onClick: () => onJoinMeeting && onJoinMeeting(row),
        });
      }
      // Always allow delete
      items.push({
        label: 'Delete Candidate',
        icon: <TrashIcon />,
        permission: [Permission.USERS_DELETE],
        onClick: () => onDelete(row),
      });

      return items;
    };
